import React from 'react';
import { SpirtEditor } from "./SpirtEditor";
import { EditorContextProvder } from "@/src/context/EditorContext";

export default () => (
  <EditorContextProvder>
    <SpirtEditor />
  </EditorContextProvder>
);